import {onUnmounted} from "vue";
import {cos, getSetting} from "@/util/cos";
import {UploadRequestOption} from "ant-design-vue/lib/vc-upload/interface";
import dayjs from "dayjs";

(window as any).dayjs = dayjs;

export function useCosUploader() {
    const taskIds: Record<string, boolean> = {};

    onUnmounted(() =>  {
        Object.keys(taskIds).map(id => cos.cancelTask(id))
    })

    async function cosRequest(param: UploadRequestOption) {
        const setting = await getSetting();
        if (!setting) {
            if (param.onError) {
                param.onError(new Error("cos初始化失败"));
            }
            return;
        }
        if (!(param.file instanceof File)) {
            if (param.onError) {
                param.onError(new Error("请选择文件上传"));
            }
            return;
        }
        if (param.file.name.lastIndexOf(".") === -1) {
            if (param.onError) {
                param.onError(new Error("文件后缀不正确"));
            }
            return;
        }
        try {
            let taskId: string | undefined = undefined;
            const res = await cos.uploadFile({
                Bucket: setting.bucket,
                Region: setting.region,
                Key: setting.prefix + "/" + dayjs().format("YYYY/MM/DD/HHmmss") + Math.round((Math.random() * 1000000)).toString().padStart(6, "0")  + param.file.name.slice(param.file.name.lastIndexOf(".")),
                SliceSize: 1024 * 1024 * 5,
                Body: param.file,
                onFileFinish(err) {
                    if (param.onError && err) {
                        param.onError(err);
                    }
                    if (taskId) {
                        delete taskIds[taskId];
                    }
                },
                onTaskReady(param) {
                    taskId = param;
                    taskIds[taskId] = true;
                },
                onProgress(progress) {
                    if (param.onProgress) {
                        param.onProgress({
                            percent: progress.percent * 100,
                        })
                    }
                },
            })
            if (param.onSuccess) {
                param.onSuccess({path: "//" + res.Location});
            }
        } catch (e) {
            if (param.onError && e instanceof Error) {
                param.onError(e);
            }
        }
    }

    return cosRequest;
}
